/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_TitleInputs */



/**
* | output |
* | --- |
* | "Welcome" |
*
* @param {Login_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_page_title = /** @type {((inputs?: Login_Page_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bienvenue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bienvenido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Bem-vindo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Benvenuto")
	return /** @type {LocalizedString} */ ("Welcome")
});